import { render, staticRenderFns } from "./TierFormDrawer.vue?vue&type=template&id=a33d8d88&scoped=true"
import script from "./TierFormDrawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./TierFormDrawer.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TierFormDrawer.vue?vue&type=style&index=0&id=a33d8d88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a33d8d88",
  null
  
)

export default component.exports